import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { usePublicImageUrl } from '../../hooks/usePublicResource'
import { useThemeType } from '../../hooks/useThemeType'
import { localStorageHelper } from '../../utils/localStorageHelper'

const firmLogoResourceIdentifier = 'firm_logo.png'

const ThemeLogo = ({ className, style, url, darkUrl, alt }) => {
  const resourceUrl = usePublicImageUrl(firmLogoResourceIdentifier)
  const themeType = useThemeType()
  const storedBrand = localStorageHelper.tryLoad('sws-brand-info')
  const src = useMemo(() => {
    if (themeType === 'light') {
      return storedBrand?.logoUrl || url || resourceUrl
    }
    if (themeType === 'dark') {
      return darkUrl || url || resourceUrl
    }
    return 'var(--root-bg-color)'
  }, [themeType, url, resourceUrl, darkUrl, storedBrand?.logoUrl])

  if (!url) return null

  return (
    <img style={style} className={className} src={src} alt={alt} />
  )
}

ThemeLogo.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string,
  darkUrl: PropTypes.string,
  style: PropTypes.object,
  alt: PropTypes.string
}

ThemeLogo.defaultProps = {
  className: undefined,
  alt: 'Firm Logo'
}

export default ThemeLogo
